import { logger } from './logger'
import { handleRequest, METHOD } from './handleRequest'
import { AjaxMetricsPublisher } from './metrics'
import { ActionProp, WidgetStatus } from '../common/props'

interface AjaxInfo {
  endpoint: string
  timeout?: number
}

interface EmbeddedImage {
  altText: string
  link: string
}

export interface FeatureResponse {
  anchorId: string
  title: string
  content?: string
  multiLineContent?: string[]
  embeddedImage?: EmbeddedImage
  externalLink?: ActionProp
  internalLink?: ActionProp
  widgetStatus?: WidgetStatus
}
export const ajaxFetchFeatureData = async (ajaxInfo: AjaxInfo): Promise<any> => {
  //[GET]/ccx/ajax/new-features
  const { endpoint = '' } = ajaxInfo

  if (endpoint === '') {
    logger.error('ajax request failed with no endpoint')
    return []
  }

  const logMessage = `asyncRequests - fetchFeaturesModalInfo for endpoint: ${endpoint}.`
  return handleRequest(
    {
      url: endpoint,
      method: METHOD.GET,
      timeout: ajaxInfo.timeout,
    },
    logMessage,
    AjaxMetricsPublisher
  )
}
